const EditIcon = ({
  color = "white",
  width = "20px",
  height = "20px",
  sx = {},
}) => {
  return (
    <svg
      style={{
        ...sx,
      }}
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m19.91,11.5l1.79-1.79c.39-.39.39-1.02,0-1.41l-3-3c-.39-.39-1.02-.39-1.41,0l-1.79,1.79,4.41,4.41Z" />
      <path d="m14.09,8.5l-7.79,7.79c-.19.19-.29.44-.29.71v3c0,.55.45,1,1,1h3c.27,0,.52-.11.71-.29l7.79-7.79-4.41-4.41Z" />
      <path d="m11.6,6.39l-2.77-1.23-1.23-2.77c-.11-.24-.34-.39-.6-.4-.27-.02-.5.15-.61.39l-1.23,2.67-2.78,1.34c-.23.11-.38.35-.38.61s.16.49.4.6l2.77,1.23,1.23,2.77c.11.24.35.4.61.4s.5-.15.61-.4l1.23-2.77,2.77-1.23c.24-.11.4-.35.4-.61s-.16-.5-.4-.61Z" />
      <path d="m21.76,18.63l-1.66-.74-.74-1.66c-.06-.14-.21-.24-.36-.24-.16-.01-.3.09-.37.23l-.74,1.6-1.67.8c-.14.07-.23.21-.23.37s.1.3.24.36l1.66.74.74,1.66c.06.14.21.24.37.24s.3-.09.37-.24l.74-1.66,1.66-.74c.14-.06.24-.21.24-.37s-.09-.3-.24-.37Z" />
    </svg>
  );
};

export default EditIcon;
